import { defineComponent, ref, watch, PropType } from 'vue';

export interface ProjectItem {
  id: string;
  desc: string;
}

export default defineComponent({
  props: {
    preSelectedProjectId: {
      type: String,
      required: false
    },
    projectItems: {
      type: Array as PropType<ProjectItem[]>,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Selecciona un proyecto'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    // Keep selectedItem in sync with preSelectedProjectId and projectItems
    const selectedItem = ref<ProjectItem | null>(
      props.preSelectedProjectId
        ? props.projectItems.find((p: any) => p.id?.toString() === props.preSelectedProjectId?.toString()) || null
        : null
    );

    watch(
      [() => props.preSelectedProjectId, () => props.projectItems],
      ([val, items]) => {
        if (!val) {
          selectedItem.value = null;
          return;
        }
        const found = items.find((p: any) => p.id?.toString() === val.toString());
        selectedItem.value = found || null;
      },
      { immediate: true }
    );

    watch(selectedItem, val => {
      emit('update:modelValue', val ? val.id : null);
    });

    const onProjectSelected = (val: ProjectItem | null) => {
      emit('change', val ? val.id : null);
    };

    const isItemSelected = (item: ProjectItem) => {
      return selectedItem.value && selectedItem.value.id === item.id;
    };

    return {
      selectedItem,
      onProjectSelected,
      isItemSelected
    };
  }
});
